import { withTranslation } from "react-i18next";

import React from 'react';
// import { connect } from 'react-redux';
// import { forgetPassword } from '../../../Action/forgetPassword';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import {Link} from 'react-router-dom';

class ResetPasswordMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <div className="container-fluid mb-5 pb-5">
                    <div className="container">
                        <div className="col-md-12">
                            <div>
                                <Header />
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="col-md-12 tr_blank_big">
                                <div className="">

                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_big">
                                <div className="">

                                </div>
                            </div>
                            <div className="col-md-12" style={{minHeight: "400px"}}>
                                <div className="row">
                                    <div className="col-md-3">
                                    </div>
                                    <div className="col-md-6 form-group ">
                                        <div className="reg_first" style={{borderBottom: "1px solid #e6e6e6"}}><b>{this.props.t('0')}</b></div>
                                        <div><br/></div>
                                        <div className="">
                                            <span className="weighted_text"><b>{this.props.t('1')}</b></span>
                                            <br />
                                            <span className="weighted_text" style={{ fontSize: '10px' }}><b>{this.props.t('2')}</b></span>
                                            <br />
                                            <br />
                                            <span className="weighted_text" style={{ fontSize: '14px' }}><b>
                                                <Link to={'/'}>
                                                    {this.props.t('3')}
                                                </Link>
                                            </b></span>
                                        </div>
                                    </div>
                                    <div className="col-md-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" mt-5 pt-5">

                    <Footer />
                </div>
            </div>
        )
    }
}
export { ResetPasswordMessage }

 ResetPasswordMessage = withTranslation('src_Components_ResetPassword_ResetPasswordMessage')(ResetPasswordMessage);